import styled from 'styled-components/macro';

import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast,
} from "@chakra-ui/react";
import {useState} from "react";
import {useFeedback} from "../store/feedback";
import {useIncreaseSubscriptionPrice} from "../api/payments";

const IncreaseProSubscriptionPrice = styled(({className, currentPrice, onClose}) => {
    const [price, setPrice] = useState(currentPrice);
    const {error, feedbackCh} = useFeedback();
    const increaseSubscriptionPrice = useIncreaseSubscriptionPrice(feedbackCh);
    const toast = useToast();
    const handleSave = async () => {

        if (price < 6.99) {
            toast({
                title: `Sorry, the minimum is $6.99.`,
                status: 'error',
                isClosable: true,
            });
            return;
        } else if (price > 500) {
            toast({
                title: `Sorry, the maximum is $500.00.`,
                status: 'error',
                isClosable: true,
            });
            return;
        }

        try {
            await increaseSubscriptionPrice(price);
            toast({
                title: `Success - thank you!`,
                status: 'success',
                isClosable: true,
            });
            onClose();
            return;
        } catch {}

        toast({
            title: `Something went wrong.`,
            status: 'error',
            isClosable: true,
        });

    };
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Increase contribution</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>

                    <p>
                        We appreciate your support.
                    </p>
                    <p style={{marginTop: 8}}>
                        All contributions over $6.99 per month include Pro.
                    </p>

                    <FormControl style={{marginTop: 16}}>
                        <FormLabel>Your monthly contribution</FormLabel>
                        <Input type="number" placeholder={price} value={price} onChange={(e) => setPrice(e.currentTarget.value)}/>
                    </FormControl>

                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Go back</Button>
                    <Button variant="blue" onClick={handleSave}>
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
`;

export default IncreaseProSubscriptionPrice;
